import * as yup from "yup";

// Login Validation
export const loginCredentialsSchema = yup.object().shape({
  email: yup.string().email().required(),
  password: yup.string().required("No password provided."),
});

// Signup Validation
export const signupCredentialsSchema = yup.object().shape({
  username: yup
    .string()
    .min(3, "User name must be at least 3 characters")
    .required(),
  email: yup.string().email().required(),
  first_name: yup
    .string()
    .min(3, "First name must be at least 3 characters")
    .required(),
  last_name: yup
    .string()
    .min(3, "Last name must be at least 3 characters")
    .required(),
  password1: yup
    .string()
    .min(8, "Password is too short - should be 8 chars minimum."),
  password2: yup
    .string()
    .oneOf([yup.ref("password1"), null], "Passwords must match"),
});
// Login Validation
export const forgetPasswordCredentialsSchema = yup.object().shape({
  email: yup.string().email().required(),
});

// Login Validation
export const serviceCredentialsSchema = yup.object().shape({
  name: yup.string().required(),
  amount_per_unit: yup.number().integer().min(1).required(),
});

// Product  Validation
export const nameCredentialsSchema = yup.object().shape({
  name: yup.string().required(),
});

// Raw Materials Validation
export const rawMaterialsCredentialsSchema = yup.object().shape({
  raw_material: yup.string().required(),
  cost: yup.string().required("Cost is a required field"),
  quantity: yup.string().required("Quantity is a required field"),
});

// Raw Materials Validation
export const ProductInventoryCredentialsSchema = yup.object().shape({
  product: yup.string().required("Product is a required field"),
  quantity: yup.string().required("Quantity is a required field"),
  raw_materials: yup
    .array()
    .of(
      yup.object({
        raw_material: yup.string().required("Raw material is required"),
        quantity: yup.string().required("Quantity is required"),
      })
    )
    .min(1, "At least one raw material is required"),

  expenses: yup
    .array()
    .of(
      yup.object({
        name: yup.string().required("Name is required"),
        cost: yup.string().required("Cost is required"),
      })
    )
    .min(1, "At least one expense is required"),
});

// Product  Validation
export const salesCredentialsSchema = yup.object().shape({
  buyer_name: yup.string().required(),
  product: yup.string().required(),
  quantity: yup.string().required(),
});

// Product  Validation
export const adminCredentialsSchema = yup.object().shape({
  email: yup.string().email().required(),
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  role: yup.string().required(),
});
export const ResetPasswordCredentialsSchema = yup.object().shape({
  password1: yup
    .string()
    .min(8, "Password is too short - should be 8 chars minimum."),
  password2: yup
    .string()
    .oneOf([yup.ref("password1"), null], "Passwords must match"),
});

// Role Creation Validation
export const roleCredentialsSchema = yup.object().shape({
  name: yup.string().required("Role Name is Required"),
});

// Raw Materials Validation
export const CropCredentialsSchema = yup.object().shape({
  name: yup.string().required("Crop name is a required field"),
  description: yup.string().required("Crop description is a required field"),
});
